module.exports = __webpack_public_path__ + "static/media/uncheck-default.29d32236.svg";